import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UnitDataType } from "../../../types/UnitDirectory/UnitDirectoryTypes";

const defaultUnitData: UnitDataType = {
  unit_id: 0,
  unit_name: "Default Unit",
  bin_data_last_15min: {
    timestamp: "N/A",
    hvac_sn: "HVAC-0000",
    ENERGY_USAGE_KWH: 0,
    ENERGY_SAVINGS_KWH: 0,
    CARBON_REDUCTION_SAVINGS: 0,
    SENSOR1_TEMP_AVG_F: 0,
    SENSOR1_TEMP_MIN_F: 0,
    SENSOR1_TEMP_MAX_F: 0,
    SENSOR2_TEMP_AVG_F: 0,
    SENSOR2_TEMP_MIN_F: 0,
    SENSOR2_TEMP_MAX_F: 0,
    SENSOR3_TEMP_AVG_F: 0,
    SENSOR3_TEMP_MIN_F: 0,
    SENSOR3_TEMP_MAX_F: 0,
    "kw/tonnage": "N/A",
    running_status: false,
  },
  active_alerts_data: {
    active_alerts: 0,
    monthly_alerts: {
      JAN: 0,
      FEB: 0,
      MAR: 0,
      APR: 0,
      MAY: 0,
      JUN: 0,
      JUL: 0,
      AUG: 0,
      SEP: 0,
      OCT: 0,
      NOV: 0,
      DEC: 0,
    },
    cmms_name: "",
    cmms_link: "",
  },
  pace_ai_version: "N/A",
  firmware_version: "N/A",
  electric_demand_last_15min: 0,
  demand_response: false,
  pace_device_serial_number: "N/A",
};

export interface UnitDirectoryState {
  unitData: UnitDataType;
}

const initialState: UnitDirectoryState = {
  unitData: defaultUnitData,
};

export const UnitDirectorySlice = createSlice({
  name: "unitDirectory",
  initialState,
  reducers: {
    setAllUnitData: (state, action: PayloadAction<UnitDataType>) => {
      state.unitData = action.payload;
    },
  },
});

export const { setAllUnitData } = UnitDirectorySlice.actions;

export const selectAllUnitData = (state: { unitDirectory: UnitDirectoryState }) => state.unitDirectory.unitData;

export default UnitDirectorySlice.reducer;
